import { ReactElement } from 'react';
import { Collapse } from '@mui/material';

import { useDashboardVariantV2CarrierHeaderExpandMoreContext } from '../Context';

import { DashboardVariantV2CarrierHeaderExpandMoreCollapseProps } from './types';

const DashboardVariantV2CarrierHeaderExpandMoreCollapse = ({
  children,
}: DashboardVariantV2CarrierHeaderExpandMoreCollapseProps): ReactElement => {
  const { expand } = useDashboardVariantV2CarrierHeaderExpandMoreContext();

  return <Collapse in={expand}>{children}</Collapse>;
};

export default DashboardVariantV2CarrierHeaderExpandMoreCollapse;
